<!--  -->
<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        align="center"
        prop="activityName"
        label="活动名称"
        width="100"
      />
      <el-table-column
        prop="time_type_text"
        label="期限类型"
        width="100"
        align="center"
      />
      <el-table-column
        prop="appoint_day"
        label="固定天数"
        width="100"
        align="center"
      />
      <el-table-column
        align="center"
        prop="start_time_str"
        label="开始时间"
        width="150"
      />
      <el-table-column
        align="center"
        prop="end_time_str"
        label="结束时间"
        width="150"
      />
      <el-table-column
        align="center"
        prop="sign"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="choose(scope.row)">选择活动</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="newtotalr"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />
  </div>

</template>

<script>
import { activitytemplate } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: [],
      newtotalr: null,
      objr: {
        page: 1,
        pageSize: 10
      },
      id: null,
      type: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(id, type) {
      console.log('平台type', type)
      this.id = id
      this.type = type
      this.activelist()
    },
    async activelist() {
      const data = await activitytemplate({
        ...this.objr,
        platformId: this.id,
        activityType: 4
      })
      this.tableData = data.data.list
      this.newtotalr = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.activelist()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.activelist()
    },
    choose(item) {
      console.log('item', item)
      this.$emit('callbadwr', item, this.type)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
